import { WithTestId } from '../../types';
import { toKebabCase } from '../../utils/casing';
import styles from './responsiveImage.module.css';

// provide image for different pixel density
export interface ResponsiveImageUrls {
  densityX1: string;
  densityX2: string;
  densityX3: string;
}

export interface ResponsiveImageProps extends WithTestId {
  imageSrc: ResponsiveImageUrls;
  imageAlt: string;
  imageSrcMobile?: ResponsiveImageUrls;
  type?: 'mainLayout';
}

const ResponsiveImage = ({
  imageSrc,
  imageSrcMobile,
  imageAlt,
  type,
  dataTestIdPrefix,
}: ResponsiveImageProps) => (
  <picture
    className={[
      styles.imageContainer,
      type ? styles[`imageContainer--${type}`] : '',
    ].join(' ')}
    data-testid={toKebabCase(dataTestIdPrefix, 'responsiveImage')}
  >
    <source
      srcSet={`${imageSrc.densityX3} 3x, ${imageSrc.densityX2} 2x, ${imageSrc.densityX1}`}
      media="(min-width: 768px)"
    />

    {imageSrcMobile && (
      <source
        srcSet={`${imageSrcMobile.densityX3} 3x, ${imageSrcMobile.densityX2} 2x, ${imageSrcMobile.densityX1}`}
        media="(max-width: 767px)"
      />
    )}

    <img
      className={styles.image}
      src={`${imageSrc.densityX3}`}
      alt={imageAlt}
      data-testid={toKebabCase(dataTestIdPrefix, 'responsiveImage', 'img')}
    />
  </picture>
);

export default ResponsiveImage;
